
























































import { Component } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import LineChart from '@/components/Shared/LineChart.vue';
import { ManagementReportsModule } from '@/store/modules/managementReports';
import { formatNumber, formatChangePercent } from '@/lib/reportFormatters';

@Component({ name: 'SpecOutReports', components: { LineChart } })
export default class SpecOutReports extends GiganautVue {

  byUserHeaders = [
    { text: 'User', value: 'userName' },
    { text: 'Spec Outs Sent', value: 'sent', align: 'end' },
    { text: 'Contacts Reached', value: 'contacts', align: 'end' },
  ];

  get specOutVolume() { return ManagementReportsModule.specOutVolume; }

  get trendChart() {
    const trend = this.specOutVolume ? this.specOutVolume.trend : [];
    return {
      labels: trend.map(t => t.period),
      datasets: [
        {
          label: 'Spec Outs Sent',
          borderColor: '#ff9800',
          backgroundColor: 'rgba(255,152,0,0.1)',
          data: trend.map(t => t.sent),
          fill: true,
        },
        {
          label: 'Contacts Reached',
          borderColor: '#2196f3',
          backgroundColor: 'rgba(33,150,243,0.1)',
          data: trend.map(t => t.contacts),
          fill: true,
        },
      ],
    };
  }

  get numberChartOptions() {
    return {
      responsive: true,
      maintainAspectRatio: false,
      scales: { yAxes: [{ ticks: { beginAtZero: true } }] },
    };
  }

  fmtNum(v: number) { return formatNumber(v); }
  fmtChange(v: number) { return formatChangePercent(v); }
}
